import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn, UserPlus } from 'lucide-react';
import { Button } from '../../components/ui/button';

const PortalLanding = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_f40446d8-d7d2-4086-ac19-be3f085557d2/artifacts/2lbvgq55_Cane%20Corso%20Logo-05.png"
            alt="Cane Corso Logo"
            className="h-32 w-32 mx-auto mb-6 object-contain"
          />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t('nav.memberPortal')}
          </h1>
          <p className="text-lg text-gray-600">
            Dernek üyeleri için özel portal alanına hoş geldiniz
          </p>
        </div>

        <div className="space-y-4">
          <Link to="/portal/login" className="block">
            <Button className="w-full bg-red-600 hover:bg-red-700 py-6 text-lg">
              <LogIn size={24} className="mr-3" />
              {t('portal.login.title')}
            </Button>
          </Link>

          <Link to="/portal/register" className="block">
            <Button variant="outline" className="w-full border-2 border-red-600 text-red-600 hover:bg-red-50 py-6 text-lg">
              <UserPlus size={24} className="mr-3" />
              {t('portal.register.title')}
            </Button>
          </Link>
        </div>

        <div className="mt-8 p-6 bg-white rounded-lg shadow-md">
          <h3 className="font-semibold text-gray-900 mb-3">Üye Portal Özellikleri:</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            <li>✓ Köpek kayıt ve yönetimi</li>
            <li>✓ Eşleşme planlaması</li>
            <li>✓ Uygun köpek arama</li>
            <li>✓ Dernek duyurularına erişim</li>
            <li>✓ Üretici bilgileri güncelleme</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PortalLanding;
